<script>
import { modalState, showModal } from "@app/store/modalStore.svelte.js";
import { fade } from "svelte/transition";
import { onMount } from "svelte";
import * as m from "@app/paraglide/messages.js";
import {
    getDeepLinkTarget,
    buildDeepLinkUrl,
    getHandoffPreference,
    setHandoffPreference,
} from "@app/lib/desktopHandoff.js";

const target = getDeepLinkTarget();
const deepLinkUrl = buildDeepLinkUrl(target);

let remember = $state(false);
let launched = $state(false);

onMount(() => {
    /* Remembered "desktop" preference: fire straight away. The fallback panel
       below still renders, so this is never a silent redirect into a dead end -
       and a programmatic external-scheme navigation without a user gesture may
       be blocked outright, in which case the panel is the only way through. */
    if (deepLinkUrl && getHandoffPreference() === "desktop") {
        launched = true;
        window.location.href = deepLinkUrl;
    }
});

function openInDesktop() {
    /* Deliberately does not preventDefault: the <a href> performs the external
       navigation natively, which is the most reliable trigger and guarantees
       the browser treats it as a user gesture. */
    if (remember) {
        setHandoffPreference("desktop");
    }

    launched = true;
}

function continueInBrowser() {
    if (remember) {
        setHandoffPreference("browser");
    }

    /* Fall through to the import the browser would have run on its own. */
    showModal(target.modal);
}
</script>

<div transition:fade={{duration: 100}} class="modal {modalState.selected === 'openInDesktop' ? 'show d-block' : ''}"
    role="dialog"
    aria-labelledby="openInDesktopTitle"
    aria-modal="true"
    tabindex="-1"
    id="OpenInDesktopModal">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title" id="openInDesktopTitle">{m.open_in_desktop_title()}</h4>
            </div>
            <div class="modal-body">
                {#if deepLinkUrl}
                    <p>{m.open_in_desktop_message()}</p>
                    <div class="form-check mb-3">
                        <input class="form-check-input"
                            type="checkbox"
                            id="rememberDesktopChoice"
                            bind:checked={remember}>
                        <label class="form-check-label small" for="rememberDesktopChoice">
                            {m.open_in_desktop_remember()}
                        </label>
                    </div>
                    <div class="d-flex gap-2 justify-content-end">
                        <button class="btn btn-secondary"
                            id="continueInBrowserBtn"
                            type="button"
                            onclick={continueInBrowser}>{m.open_in_desktop_continue_button()}</button>
                        <a class="btn btn-primary"
                            id="openInDesktopBtn"
                            href={deepLinkUrl}
                            onclick={openInDesktop}>{m.open_in_desktop_button()}</a>
                    </div>
                    {#if launched}
                        <hr>
                        <p class="small mb-1">{m.open_in_desktop_launching()}</p>
                        <p class="small text-muted mb-0">
                            {m.open_in_desktop_fallback_message()}
                            <a href="https://www.closedcaptioncreator.com/downloads.html" target="_blank">
                                {m.open_in_desktop_download_link()}
                            </a>
                        </p>
                    {/if}
                {:else}
                    <p>{m.open_in_desktop_too_large_message()}</p>
                    <div class="d-flex justify-content-end">
                        <button class="btn btn-primary"
                            id="continueInBrowserBtn"
                            type="button"
                            onclick={continueInBrowser}>{m.open_in_desktop_continue_button()}</button>
                    </div>
                {/if}
            </div>
        </div>
    </div>
</div>
